<template>
  <div :class="{english:lang=='EN',russian:lang=='RU'}">
    <div class="hidden-xs">
      <div class="product" ref="product">
        <div class="wow animated fadeInUp" style="display:flex;align-items: center;flex-direction: column;">
          <div class="product-title">{{ $t(title) }}</div>
          <div class="product-describe">{{ $t(describe) }}</div>
        </div>
<!--        <div style="width: 100%;align-items: center;display: flex;justify-content: center;">-->
<!--          <div class="product-ul wow animated fadeInUp">-->
<!--            <div class="product-item pointer" v-for="item in tabItems"-->
<!--                 @mouseenter="changeHoverTab(item.tab)"-->
<!--                 @mouseleave="changeHoverTab()"-->
<!--                 @click="changeTab(item.tab)"-->
<!--                 :key="item.tab"-->
<!--            >-->
<!--              <img v-if="curTab == item.tab || curHoverTab == item.tab" class="item-img" :src="item.iconActivePath"/>-->
<!--              <img v-else class="item-img" :src="item.iconPath"/>-->
<!--              <span class="item-title"-->
<!--                    :class="{active:curTab==item.tab || curHoverTab == item.tab}">{{ $t(item.title) }}</span>-->
<!--              <div class="triangle-up" v-if="curTab==item.tab"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="wrapper">-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content robot" v-show="curTab == 'robot'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.logisticsProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.logisticsDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartRobot()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                <div @click="openRobotVideo" class="operate-button view-video">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.viewVideo')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="vide-play"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="active-item item" @click="openSmartRobot('guide')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="active-item item" @click="openSmartRobot('delivery')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="active-item item" @click="openSmartRobot('security')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail4') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject5') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail5') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject6') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail6') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject7') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail7') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content car" v-show="curTab == 'car'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.warehouseProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.warehouseDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartCar()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                <div @click="openCarVideo" class="operate-button view-video">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.viewVideo')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="vide-play"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartCar">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail4') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content terminal" v-show="curTab == 'terminal'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.containerProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.containerDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartTerminal()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                <div @click="openTerminalVideo" class="operate-button view-video">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.viewVideo')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="vide-play"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartTerminal('AccessControl')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartTerminal('ADAS')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartTerminal('thermometer')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail4') }}-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content chip" v-show="curTab == 'chip'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.supplyChainProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.supplyChainDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartChip()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartChip('LocChip')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartChip('TerminalCore')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail4') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--        </div>-->
      </div>
    </div>
    <div class="visible-xs">
      <div class="product" ref="product">
        <div class="wow animated fadeInUp" style="display:flex;align-items: center;flex-direction: column;">
          <div class="product-title">{{ $t(title) }}</div>
          <div class="product-describe">{{ $t(describe) }}</div>
        </div>
<!--        <div style="width: 100%;align-items: center;display: flex;justify-content: center;">-->
<!--          <div class="product-ul wow animated fadeInUp">-->
<!--            <div class="product-item pointer" v-for="(item,index) in tabItems" :key="index"-->
<!--                 @mouseenter="changeHoverTab(item.tab)" @mouseleave="changeHoverTab()" @click="changeTab(item.tab)">-->
<!--              <img v-if="curTab == item.tab || curHoverTab == item.tab" class="item-img" :src="item.iconActivePath"/>-->
<!--              <img v-else class="item-img" :src="item.iconPath"/>-->
<!--              <span class="item-title"-->
<!--                    :class="{active:curTab==item.tab || curHoverTab == item.tab}">{{ $t(item.title) }}</span>-->
<!--              <div class="triangle-up" v-if="curTab==item.tab"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="wrapper">-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content robot" v-show="curTab == 'robot'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.logisticsProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.logisticsDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartRobot()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                <div @click="openRobotVideo" class="operate-button view-video">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.viewVideo')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="vide-play"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="active-item item" @click="openSmartRobot('guide')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="active-item item" @click="openSmartRobot('delivery')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="active-item item" @click="openSmartRobot('security')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail4') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject5') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail5') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject6') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail6') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.logisticsProject7') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.logisticsDetail7') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content car" v-show="curTab == 'car'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.warehouseProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.warehouseDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartCar()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                <div @click="openCarVideo" class="operate-button view-video">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.viewVideo')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="vide-play"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartCar">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.warehouseProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.warehouseDetail4') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content terminal" v-show="curTab == 'terminal'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.containerProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.containerDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartTerminal()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                &lt;!&ndash;                <div @click="openTerminalVideo" class="operate-button view-video">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.viewVideo')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="vide-play"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartTerminal('AccessControl')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartTerminal('ADAS')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartTerminal('thermometer')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.containerProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.containerDetail4') }}-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--          &lt;!&ndash; </transition> &ndash;&gt;-->
<!--          &lt;!&ndash; <transition name="fade"> &ndash;&gt;-->
<!--          <div class="content chip" v-show="curTab == 'chip'">-->
<!--            <div class="left">-->
<!--              <div class="title">{{ $t('home.supplyChainProject0') }}</div>-->
<!--              <div class="info">{{ $t('home.supplyChainDetail0') }}</div>-->
<!--              <div class="operate">-->
<!--                &lt;!&ndash;                <div @click="openSmartChip()" class="operate-button understand-more">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{$t('common.learnMore')}}&ndash;&gt;-->
<!--                &lt;!&ndash;                  <div class="unserstand-more-logo"></div>&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="right">-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartChip('LocChip')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject1') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail1') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              &lt;!&ndash;              <div class="item active-item" @click="openSmartChip('TerminalCore')">&ndash;&gt;-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject2') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail2') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject3') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail3') }}-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="item">-->
<!--                <div class="name">-->
<!--                  {{ $t('home.supplyChainProject4') }}-->
<!--                </div>-->
<!--                <div class="caption">-->
<!--                  {{ $t('home.supplyChainDetail4') }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import {mapGetters} from 'vuex'

export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      title: 'home.product',
      describe: 'home.describe',
      curTab: 'robot',
      curHoverTab: '',
      tabItems: [
        {
          tab: 'robot',
          title: 'home.logistics',
          iconPath: require('../../../assets/img/mainpage/logistics1.png'),
          iconActivePath: require('../../../assets/img/mainpage/logistics2.png'),
        },
        {
          tab: 'car',
          title: 'home.warehouse',
          iconPath: require('../../../assets/img/mainpage/warehouse1.png'),
          iconActivePath: require('../../../assets/img/mainpage/warehouse2.png')
        },
        {
          tab: 'terminal',
          title: 'home.container',
          iconPath: require('../../../assets/img/mainpage/container1.png'),
          iconActivePath: require('../../../assets/img/mainpage/container2.png')
        },
        {
          tab: 'chip',
          title: 'home.supplyChain',
          iconPath: require('../../../assets/img/mainpage/supplyChain1.png'),
          iconActivePath: require('../../../assets/img/mainpage/supplyChain2.png')
        },
      ],
      // video: {
      //   terminalVideo: require('../../../assets/video/smart_terminal.mp4'),
      //   robotVideo: require('../../../assets/video/smart_robot.mp4'),
      //   carVideo: require('../../../assets/video/smart_car.mp4')
      // }
    }
  },
  methods: {
    changeHoverTab (tab) {
      this.curHoverTab = tab
    },
    changeTab (tab) {

      this.$nextTick(() => {

        $('.product .wrapper .content').hide()
        this.curTab = tab
        $('.product .wrapper .content.' + tab).slideDown(500)
        // var h=$('.product .wrapper').height()
        //  setTimeout(() => {
        //   // $('.product .wrapper').height(h)
        //   // $('.visible-xs .product .wrapper').height($('.visible-xs .product .wrapper .content').height())
        // },500)

      })

    },
    openSmartRobot (p) {
      this.$router.push({
        name: 'smartRobot', params: {
          position: p
        }
      })
    },
    openSmartTerminal (p) {
      this.$router.push({
        name: 'smartTerminal',
        params: {
          position: p
        }
      })
    },
    openSmartCar () {
      this.$router.push({
        name: 'smartCar'
      })
    },
    openSmartChip (p) {
      this.$router.push({
        name: 'smartChip',
        params: {
          position: p,
        }
      })
    },
    openTerminalVideo () {
      this.$emit('openVideo', {srcPath: this.video.terminalVideo})
    },
    openRobotVideo () {
      this.$emit('openVideo', {srcPath: this.video.robotVideo})
    },
    openCarVideo () {
      this.$emit('openVideo', {srcPath: this.video.carVideo})
    }
  },
  mounted () {
    const wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: false,
      live: false
    })
    wow.init()
    this.$nextTick(() => {
      // setTimeout(() => {
      // $('.product .wrapper').height($('.product .wrapper .content').height())
      // $('.visible-xs .product .wrapper').height($('.visible-xs .product .wrapper .content').height())
      // }, 0)
      window.eventBus.$on('videoHide', () => {
        // setTimeout(() => {
        // $('.product .wrapper').height($('.product .wrapper .content').height())
        // $('.visible-xs .product .wrapper').height($('.visible-xs .product .wrapper .content').height())
        // }, 0)
      })
    })
  },
  computed: {
    ...mapGetters(['lang']),
    getComponentName () {
      return ''
    }
  },
  watch: {}

}
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  // transition: opacity .5s;
  height: auto;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  height: auto;
}
</style>
<style lang="scss" scoped>
.product {
  position: relative;
  width: 100%;
  background: #F3F6FB;
  margin-top: -0.5rem;
  z-index: 100;

  .pointer {
    cursor: pointer;
  }

  .product-title {
    margin-top: 7rem;
    font-size: 3rem;
    font-family: Arial, Source Han Sans CN;
    font-weight: 200;
    color: rgba(63, 74, 93, 1);
    line-height: 4.38rem;
    letter-spacing: 0.25rem;
  }

  .product-describe {
    width: 60rem;
    margin-top: 3rem;
    font-size: 2rem;
    text-indent: 4rem;
    font-family: Arial, Source Han Sans CN;
    font-weight: 200;
    color: rgba(63, 74, 93, 1);
    line-height: 3.38rem;
    letter-spacing: 0.25rem;
  }

  .product-ul {
    display: flex;
    justify-content: center;
    width: 100%;
    max-width: 60rem;
    display: flex;
    justify-content: space-between;

    .product-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 1.125rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 400;
      color: #3F4A5D;
      margin: 6rem 0 3.75rem 0;

      img {
        width: 5.88rem;
        height: 5.88rem;
        margin-bottom: 0.75rem;
        // border:1px dashed rgba(0, 0, 0, 0.6);
      }

      .active {
        color: #2D8FFF;
      }

      .triangle-up {
        width: 0;
        height: 0;
        border-left: 1rem solid transparent;
        border-right: 1rem solid transparent;
        border-bottom: 1.25rem solid #EBEEF2;
        position: absolute;
        bottom: -1px;
      }
    }
  }

  .wrapper {
    width: 100%;
    height: 100%;
    // max-height: 25rem;
    display: flex;
    justify-content: center;
    background: #EBEEF2;
    transition: height .24s ease-out;
    padding-top: 3rem;
    padding-bottom: 3.5rem;

    .content {
      width: 100%;
      max-width: 75rem;
      display: flex;
      padding-bottom: 0.5rem;
      .left {
        width: 29rem;
        // margin-top: 3rem;
        .title {
          font-size: 1.88rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
          white-space: pre-wrap;
        }

        .info {
          font-size: 0.88rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 300;
          color: rgba(138, 152, 178, 1);
          line-height: 1.25rem;
          margin-top: 1rem;
          max-width: 90%;
        }

        .operate-button {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          /*width: 14.33rem;*/
          /*height: 4.25rem;*/
          width: 10.75rem;
          height: 3.19rem;
          margin-top: 2rem;
        }

        .operate {
          display: flex;
          justify-content: left;

          .operate-button {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 10.75rem;
            height: 3.19rem;
          }

          .understand-more {
            background: url("../../../assets/img/mainpage/button01.png") no-repeat;
            background-size: contain;
            margin-right: 1.5rem;

            .unserstand-more-logo {
              background: url("../../../assets/img/mainpage/arrow_black.png") no-repeat;
              background-size: contain;
              width: 1.21rem;
              height: 0.525rem;
              margin-left: 0.375rem;
            }
          }

          .understand-more:hover {
            color: #FFFFFF;
            background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
            background-size: contain;

            .unserstand-more-logo {
              background: url("../../../assets/img/mainpage/Arrow.png") no-repeat;
              background-size: contain;
              width: 1.21rem;
              height: 0.525rem;
              margin-left: 0.375rem;
            }
          }

          .view-video {
            background: url("../../../assets/img/mainpage/button01.png") no-repeat;
            background-size: contain;

            .vide-play {
              background: url("../../../assets/img/mainpage/icon_play_black.png") no-repeat;
              background-size: contain;
              width: 1.06rem;
              height: 1.06rem;
              margin-left: 0.375rem;
            }
          }

          .view-video:hover {
            color: #FFFFFF;
            background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
            background-size: contain;

            .vide-play {
              background: url("../../../assets/img/mainpage/icon_play.png") no-repeat;
              background-size: contain;
            }
          }
        }
      }

      .right {
        width: 46rem;
        // height: 12.5rem;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        // margin-top:3rem;
        // padding-bottom: 5.5rem;
        .item {
          width: 50%;
          height: auto;
          //max-height: 9rem;
          padding: 1rem 1rem 1rem;
          position: relative;
          top: 0;
          transition: top .2s linear;
          -moz-transition: top .2s linear;
          -webkit-transition: top .2s linear;
          -o-transition: top .2s linear;

          .name {
            font-size: 1rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            line-height: 2.25rem;
          }

          .caption {
            margin-top: 0.88rem;
            font-size: 0.88rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color: rgba(138, 152, 178, 1);
            line-height: 1.50rem;
          }
        }

        .active-item:hover {
          cursor: pointer;
          top: -0.2rem;
          background: #FFFFFF;
          box-shadow: 0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.06);

          .name {
            color: rgba(70, 154, 255, 1);
          }
        }
      }
    }

    // .robot {
    //   height: 25rem;
    // }

    // .terminal, .car, .chip {
    //   height: 18.75rem;
    // }
  }

}

.visible-xs {
  .product {
    margin-top: 0rem;
    z-index: 100;

    .product-title {
      margin-top: 2rem;
      font-size: 1.5rem;
    }

    .product-describe {
      width: auto;
      margin-top: 1rem;
      font-size: 1rem;
      text-align: center;
      text-indent: 3rem;
      font-family: Arial, Source Han Sans CN;
      font-weight: 200;
      color: rgba(63, 74, 93, 1);
      line-height: 3.38rem;
      letter-spacing: 0.25rem;
    }

    .product-ul {
      display: flex;
      justify-content: center;
      width: 100%;
      max-width: 85%;
      display: flex;
      justify-content: space-between;

      .product-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.88rem;
        font-family: Arial, Source Han Sans CN;
        font-weight: 400;
        color: #3F4A5D;
        margin: 2rem 0 2rem 0;

        img {
          width: 2.94rem;
          height: 2.94rem;
          margin-bottom: 0.75rem;
        }

        .active {
          color: #2D8FFF;
        }

        .triangle-up {
          width: 0;
          height: 0;
          border-left: 0.5rem solid transparent;
          border-right: 0.5rem solid transparent;
          border-bottom: 0.625rem solid #EBEEF2;
          position: absolute;
          bottom: 0px;
        }
      }
    }
  }

  .wrapper {
    width: 100%;
    height: 100%;
    // max-height: 45rem;
    display: flex;
    justify-content: center;
    background: #EBEEF2;
    transition: height .24s ease-out;
    padding: 2rem 0;

    .content {
      width: 100%;
      max-width: 85%;
      display: flex;
      flex-direction: column;

      .left {
        width: 100%;
        // margin-top: 2rem;
        .title {
          font-size: 1rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 400;
          color: rgba(63, 74, 93, 1);
          white-space: initial;
        }

        .info {
          font-size: 0.8rem;
          font-family: Arial, Source Han Sans CN;
          font-weight: 300;
          color: rgba(138, 152, 178, 1);
          line-height: auto !important;
          margin-top: 1rem;
          max-width: 100%;
        }

        .operate-button {
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          width: 8.0625rem;
          height: 2.3925rem;
          margin-top: 1rem;
        }

        .operate {
          display: flex;
          justify-content: left;

          .operate-button {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 8.0625rem;
            height: 2.3925rem;
          }

          .understand-more {
            background: url("../../../assets/img/mainpage/button01.png") no-repeat;
            background-size: contain;
            margin-right: 1rem;

            .unserstand-more-logo {
              background: url("../../../assets/img/mainpage/arrow_black.png") no-repeat;
              background-size: contain;
              width: 0.726rem;
              height: 0.315rem;
              margin-left: 0.187rem;
            }
          }

          .understand-more:hover {
            color: #FFFFFF;
            background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
            background-size: contain;

            .unserstand-more-logo {
              background: url("../../../assets/img/mainpage/Arrow.png") no-repeat;
              background-size: contain;
              width: 0.726rem;
              height: 0.315rem;
              margin-left: 0.187rem;
            }
          }

          .view-video {
            background: url("../../../assets/img/mainpage/button01.png") no-repeat;
            background-size: contain;

            .vide-play {
              background: url("../../../assets/img/mainpage/icon_play_black.png") no-repeat;
              background-size: contain;
              width: 0.68rem;
              height: 0.68rem;
              margin-left: 0.375rem;
            }
          }

          .view-video:hover {
            color: #FFFFFF;
            background: url("../../../assets/img/mainpage/button01_active.png") no-repeat;
            background-size: contain;

            .vide-play {
              background: url("../../../assets/img/mainpage/icon_play.png") no-repeat;
              background-size: contain;
            }
          }
        }
      }

      .right {
        width: 100%;
        height: auto;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 1rem;

        .item {
          width: 100%;
          height: auto;
          padding: 1rem 0.5rem;
          position: relative;
          top: 0;
          transition: top .2s linear;
          -moz-transition: top .2s linear;
          -webkit-transition: top .2s linear;
          -o-transition: top .2s linear;

          .name {
            font-size: 0.8rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 400;
            line-height: 1rem;
          }

          .caption {
            margin-top: 0.5rem;
            font-size: 0.6rem;
            font-family: Arial, Source Han Sans CN;
            font-weight: 300;
            color: rgba(138, 152, 178, 1);
            line-height: 1rem;
          }
        }

        .active-item:hover {
          cursor: pointer;
          top: -0.2rem;
          background: #FFFFFF;
          box-shadow: 0rem 0rem 2rem 0rem rgba(0, 0, 0, 0.06);

          .name {
            color: rgba(70, 154, 255, 1);
          }
        }
      }
    }

    // .robot {
    //   height:29rem;
    // }

    // .terminal {
    //   height: 24rem;
    // }

    // .car {
    //   height: 16.5rem;
    // }

    // .chip {
    //   height: 17rem;
    // }
  }
}

.english,.russian{
  .product-title {
    letter-spacing: 0 !important;
  }

  .hidden-xs {
    // .product .wrapper{
    //   max-height: 28rem;
    // }
    //.product .wrapper .content .right .item {
    //  max-height: 8rem;
    //}

    // .robot {
    //   height: 28rem !important;
    // }

    // .terminal {
    //   height: 22rem !important;
    // }

    // .car {
    //   height: 20rem !important;
    // }

    // .chip {
    //   height:20rem !important;
    // }
  }

  .visible-xs {
    .product .wrapper .content .right .item {
      max-height: 10rem;
    }

    .product-ul {
      max-width: 95%;

      .product-item {
        width: 25% !important;
        font-size: 0.75rem !important;
        white-space: nowrap;
      }
    }

    .product .wrapper .content .left .title {
      white-space: pre-wrap;
    }

    .product .wrapper .content.terminal .left .title, .product .wrapper .content.car .left .title {
      white-space: initial;
    }

    // .robot {
    //   height: 35rem !important;
    // }

    // .terminal {
    //   height:30rem !important;
    // }

    // .car {
    //   height:20rem !important;
    // }

    // .chip {
    //   height:20rem !important;
    // }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/home/MainProduct.vue